import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiMail, FiLock, FiEye, FiEyeOff, FiShield } from 'react-icons/fi';
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-toastify';
import Logo from '../components/Logo';

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPwd, setShowPwd] = useState(false);
  const [loading, setLoading] = useState(false);
  const { login, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user?.role === 'admin') navigate('/admin');
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const result = await login(email, password);
    if (result.success) {
      if (result.user?.role === 'admin' || user?.role === 'admin') {
        toast.success('Welcome to Admin Panel!');
        navigate('/admin');
      } else {
        // Refresh check after login
        setTimeout(() => {
          if (user?.role !== 'admin') {
            toast.error('Access denied. Admin only.');
          } else navigate('/admin');
        }, 500);
      }
    } else {
      toast.error(result.message || 'Login failed');
    }
    setLoading(false);
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0d2b18 0%, #1a472a 50%, #0d2b18 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20
    }}>
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        style={{ width: '100%', maxWidth: 420, background: 'white', borderRadius: 24, overflow: 'hidden', boxShadow: '0 24px 80px rgba(0,0,0,0.4)' }}
      >
        {/* Header */}
        <div style={{ background: 'linear-gradient(135deg, #0d2b18, #1a472a)', padding: '32px 32px 24px', textAlign: 'center' }}>
          <motion.div animate={{ scale: [1, 1.05, 1] }} transition={{ duration: 2, repeat: Infinity, ease: 'easeInOut' }}>
            <Logo size={48} showText={false} />
          </motion.div>
          <h1 style={{ color: 'white', fontSize: '1.3rem', fontFamily: 'var(--font-heading)', margin: '12px 0 4px' }}>Admin Panel</h1>
          <p style={{ color: 'rgba(255,255,255,0.65)', fontSize: '0.82rem' }}>The Unexplored Routes</p>
          <div style={{ display:'inline-flex', alignItems:'center', gap:6, background:'rgba(240,192,64,0.15)', border:'1px solid rgba(240,192,64,0.3)', borderRadius:20, padding:'4px 12px', marginTop:10 }}>
            <FiShield style={{ color:'#f0c040', fontSize:'0.8rem' }} />
            <span style={{ color:'#f0c040', fontSize:'0.75rem', fontWeight:600 }}>Secure Admin Access</span>
          </div>
        </div>

        {/* Form */}
        <div style={{ padding: '28px 32px 32px' }}>
          <form onSubmit={handleSubmit} style={{ display:'flex', flexDirection:'column', gap:14 }}>
            <div style={{ position:'relative', display:'flex', alignItems:'center', background:'#f6faf6', border:'1.5px solid rgba(0,0,0,0.1)', borderRadius:12, height:50 }}>
              <FiMail style={{ position:'absolute', left:14, color:'var(--text-light)' }} />
              <input
                type="email" placeholder="Admin email" value={email}
                onChange={e => setEmail(e.target.value)} required
                style={{ flex:1, border:'none', background:'transparent', outline:'none', padding:'0 44px', fontSize:'0.92rem', fontFamily:'var(--font-body)', height:'100%' }}
              />
            </div>
            <div style={{ position:'relative', display:'flex', alignItems:'center', background:'#f6faf6', border:'1.5px solid rgba(0,0,0,0.1)', borderRadius:12, height:50 }}>
              <FiLock style={{ position:'absolute', left:14, color:'var(--text-light)' }} />
              <input
                type={showPwd ? 'text' : 'password'} placeholder="Password" value={password}
                onChange={e => setPassword(e.target.value)} required
                style={{ flex:1, border:'none', background:'transparent', outline:'none', padding:'0 44px', fontSize:'0.92rem', fontFamily:'var(--font-body)', height:'100%' }}
              />
              <button type="button" onClick={() => setShowPwd(!showPwd)} style={{ position:'absolute', right:14, background:'none', border:'none', cursor:'pointer', color:'var(--text-light)', display:'flex' }}>
                {showPwd ? <FiEyeOff /> : <FiEye />}
              </button>
            </div>

            <button type="submit" disabled={loading} style={{
              width:'100%', padding:15, background:'linear-gradient(135deg, var(--primary-dark), var(--primary-light))',
              color:'white', border:'none', borderRadius:12, fontSize:'0.97rem', fontWeight:700,
              cursor:'pointer', fontFamily:'var(--font-body)', marginTop:4,
              boxShadow:'0 5px 18px rgba(26,71,42,0.32)', opacity: loading ? 0.75 : 1
            }}>
              {loading ? 'Signing In...' : 'Sign In to Admin'}
            </button>
          </form>

          {/* <div style={{ marginTop:20, padding:14, background:'#f0f7f0', borderRadius:10, fontSize:'0.78rem', color:'var(--text-light)', textAlign:'center', lineHeight:1.6 }}>
            <strong>Default Admin:</strong><br />
            admin@theunexploredroutes.com<br />
            Password: Admin@123456
          </div> */}

          <p style={{ textAlign:'center', marginTop:16, fontSize:'0.82rem' }}>
            <a href="/" style={{ color:'var(--primary)', fontWeight:600 }}>← Back to Website</a>
          </p>
        </div>
      </motion.div>
    </div>
  );
}
